// Mirrors api-hub shared/constants/name-utils.js; the API re-checks everything on signup
const NAME_PATTERN = /^[A-Za-z0-9 .'-]+$/;
const ADDRESS_PATTERN = /^[\x20-\x7E]+$/;
const ENGLISH_LETTER = /[A-Za-z]/;
const INVISIBLE_CHARS = /[\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF]/g;
const APOSTROPHE_VARIANTS = /[\u2018\u2019\u02BC\u00B4]/g;

export const ENGLISH_ONLY_MESSAGE = 'Please use English letters';

export function normalizeEnglishText(value) {
  if (typeof value !== 'string') return value;
  return value
    .replace(INVISIBLE_CHARS, '')
    .replace(/\u00A0/g, ' ')
    .replace(APOSTROPHE_VARIANTS, "'")
    .trim();
}

// Letters NFD can't split into base + accent
const UNDECOMPOSABLE = {
  ß: 'ss',
  ẞ: 'SS',
  ø: 'o',
  Ø: 'O',
  æ: 'ae',
  Æ: 'AE',
  ł: 'l',
  Ł: 'L',
  đ: 'd',
  Đ: 'D',
  œ: 'oe',
  Œ: 'OE',
  ı: 'i'
};

// Places keeps accents (Zürich, São Paulo); fold them so a picked address passes
export function foldAccents(value) {
  if (typeof value !== 'string') return value;
  return value
    .replace(/[ßẞøØæÆłŁđĐœŒı]/g, (letter) => UNDECOMPOSABLE[letter])
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function isEnglishName(value) {
  // Only truly empty passes; a whitespace-only name (e.g. a lone NBSP) must fail
  if (!value) return true;
  const name = normalizeEnglishText(value);
  return NAME_PATTERN.test(name) && ENGLISH_LETTER.test(name);
}

export function isEnglishAddressText(value) {
  if (!value || !value.trim()) return true;
  return ADDRESS_PATTERN.test(normalizeEnglishText(value));
}
